import { Suspense, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import SmoothScroll from "@/components/layout/SmoothScroll";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import LegalPage from "@/pages/LegalPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // GTM: SPA pageview tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: pathname,
      page_title: document.title,
    });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME || ""}>
        <SmoothScroll>
          <div className="App grain min-h-screen bg-black text-white">
            <div className="ios-statusbar-scrim" aria-hidden="true" />
            <Navbar />
            <ScrollToTop />
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/disclaimer" element={<LegalPage docKey="disclaimer" />} />
                <Route path="/privacy-policy" element={<LegalPage docKey="privacy-policy" />} />
                <Route path="/cookie-policy" element={<LegalPage docKey="cookie-policy" />} />
                <Route path="/codice-etico" element={<LegalPage docKey="codice-etico" />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
            <Footer />
          </div>
        </SmoothScroll>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
